import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {AndroidIcon, IphoneIcon, GameIcon, CustomSoftIcon, SoftwareProIcon, SoftwareMainIcon} from "../../../app-constants";
import { Link } from 'gatsby'; // Import Gatsby's Link component
import HtmlParser from 'react-html-parser';


const StackItem = [
    {
        icon: AndroidIcon,
        title: 'Android app development',
        description: (
            <>
                We specialize in developing high-performance Android applications that cater to your specific audience. Our expert team leverages the latest technologies and industry best practices to deliver impeccable {' '}
                <Link to="/android-app-development" rel="noopener" aria-label="TekRevol">
                    Android app development services
                </Link> {' '}
                that are rich in features. We are dedicated to delivering apps with high functionality while maintaining a seamless user experience.
            </>
        ),

    },
    {
        icon: IphoneIcon,
        title: 'Iphone app development',
        description: (
            <>
                Harnessing the power of cutting-edge iOS technologies, we design and develop captivating iPhone applications. Our{' '}
                <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
                    iPhone app development services
                </Link> {' '}
                can align with your business objectives. We create iPhone apps that are not only visually appealing but also technically robust and user-friendly, ensuring your brand reaches its target audience effectively.
            </>
        ),

    },
    {
        icon: GameIcon,
        title: 'Game app development',
        description: (
            <>
                If you have a stunning and unique game concept, you are in the right place to turn your idea into reality. Hire the right{' '}
                <Link to="/game-development" rel="noopener" aria-label="TekRevol">
                    game app development company
                </Link> {' '}
                and capitalize on the opportunity by working with game developers known for building exceptional 3D, AR, VR, and Blockchain games. Our expertise speak for themselves considering the success of our current live games.
            </>
        ),

    },
    {
        icon: CustomSoftIcon,
        title: 'Custom Software Development',
        description: (
            <>
                Our team excels in crafting tailor-made software solutions, meticulously designed to match your unique business needs. We work closely with you to understand your requirements and deliver{' '}
                <Link to="/custom-software-development" rel="noopener" aria-label="TekRevol">
                    custom software development services
                </Link> {' '}
                that not only meet your expectations but exceed them. Our custom software development services are geared toward enhancing your operational efficiency, productivity, and overall business performance
            </>
        ),

    },
    {
        icon: SoftwareProIcon,
        title: 'Software Product Development',
        description: 'We offer end-to-end product development services, ensuring your vision is transformed into a successful, market-ready product. From ideation to product launch, we specialize in bringing your software product concepts to life. With a relentless focus on innovation and user-centered design, our seasoned developers meticulously create software products that stand out in the market.',
    },
    {
        icon: SoftwareMainIcon,
        title: 'Software Support and Maintenance',
        description: 'Our commitment to your software doesn\'t end with development. We provide continuous support and maintenance services to keep your software running smoothly. Our dedicated team monitors your application, promptly addresses issues, implements updates, and enhances its performance. You can rely on us to ensure your software remains robust, secure, and up to date.',
    },

];

function Improvise(props) {
    return (
        <div className="improvise_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                <Col xs={12} md={12} lg={12} xl={10} xxl={4} className="m-xl-auto m-xxl-0">
                        <h2>TekRevol’s Software Development Services in San Francisco</h2>
                        <p>Our software development services in San Francisco are driven by innovation, expertise, and a commitment to digital excellence. TekRevol’s skilled team excels at turning your unique vision into a reality. We offer a comprehensive range of software development services to meet your diverse needs.</p>
                        <p className="impro_para">Here is a glimpse of the services we provide:</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
                        <div className="stack_box">
                            {StackItem.map((item, index) => (
                                <div className="stack_item" key={index}>
                                    <div className="stack_title">
                                        {item.icon}
                                        <h5>{item.title}</h5>
                                    </div>
                                    <p>{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Improvise;